import { FC, useCallback, useEffect, useState } from 'react';

import FallbackImg from 'src/assets/images/fallback.png';

import classes from './Image.module.scss';

const ImageWithFallback: FC<React.ImgHTMLAttributes<HTMLImageElement>> = ({ src, ...props }) => {
  const [imageUrl, setImageUrl] = useState(src ?? FallbackImg);

  useEffect(() => {
    setImageUrl(src ?? FallbackImg);
  }, [src]);

  const onErrorCapture = useCallback(() => {
    setImageUrl(FallbackImg);
  }, [setImageUrl]);

  return <img {...props} src={imageUrl} loading='lazy' onErrorCapture={onErrorCapture} className={classes.image} />;
};

export default ImageWithFallback;
